import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/Login/ForgetPassword";

const authRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
];

export default authRoutes;